function setPlan(planEl){
  var selectElement = document.querySelector('select.dn-selling-plans');
  var selectedOption = selectElement.options[selectElement.selectedIndex];
  var planPrice = selectedOption.dataset.price;
  var selectedValue = selectedOption.value;
  var createInput = document.createElement('input');
  createInput.type = 'hidden';
  createInput.classList.add('selling_plan');
  createInput.setAttribute('name','selling_plan');
  createInput.value = selectedValue;
  
  var getActivePlan = planEl.dataset.plan;
  var form = document.querySelector('.shopify-product-form');

  var existingInput = form.querySelector('.selling_plan');
  if (existingInput) {
    existingInput.remove();
  }

  if(getActivePlan == 'subscription plan'){
    form.appendChild(createInput);
    document.querySelector('span.plan_price.subscribe_price').innerText = planPrice;
  } else if(getActivePlan == 'one time'){
  }
}

var planClass = document.querySelectorAll('.purchase_plan');

if(planClass.length > 0){
  planClass.forEach(function(planEl){
    planEl.addEventListener('click', function(){
      planClass.forEach(function(el){
        el.classList.remove('active');
      }); 
      planEl.classList.add('active');
      setPlan(planEl);
    });
  });
}
